<template>
  <div class="detailsPage">
    <navComponment></navComponment>
    <div class="main">
      <div class="detailsBanner">
        <div class="bannerText">
          <p class="text_info">SANGFOR Partner Engagement Program</p>
          <p class="text_line"></p>
        </div>
      </div>
      <div class="program_Value_Propositio">
        <div class="pvp_introduce">
          <p class="pvp_introduce_line"></p>
          <h3 class="pvp_introduce_title">PROGRAM VALUE PROPOSITION</h3>
          <p class="pvp_introduce_content">
            SANGFOR Partner Engagement Program redesigns the way we do business. The designing of SANGFOR business,
            organization, and sales
            cycle are totally partner oriented, made to deliver simplicity and innovation to partners with full support.
            We aim to build and
            enhance partner's competitiveness and help to ensure partner's profitable business.
          </p>
        </div>
        <div class="pvp_menu">
          <ul class="pvp_menu_list">
            <li v-for="(item, index) in this.pvpMenuListData" :key="item.id" @click="handleMenu(index)"
              :class="{ menuListBaColor: showMenuIndex == index }">
              {{ item.title }}
            </li>
          </ul>
          <div class="pvp_menu_content">
            <div class="pvp_menu_content_box" v-show="this.showMenuIndex == 0">
              <transition name="imgBoxFead">
                <div class="imgBox" ref="imgBox" v-show="this.showMenuIndex == 0">
                  <img :src="this.pvpMenuImg.operationExcellence" alt="Operation Excellence" />
                </div>
              </transition>
              <transition name="content_boxFead">
                <div class="content_box" v-show="this.showMenuIndex == 0">
                  <h3 class="content_box_title">{{ this.pvpMenuTitle.operationExcellence }}</h3>
                  <p class="content_box_text">{{ this.pvpMenuText.operationExcellence }}</p>
                </div>
              </transition>
            </div>
            <div class="pvp_menu_content_box" v-show="this.showMenuIndex == 1">
              <transition name="imgBoxFead">
                <div class="imgBox" v-show="this.showMenuIndex == 1">
                  <img :src="this.pvpMenuImg.agilityToScaleAndSpecialize" alt="Agility to scale and specialize" />
                </div>
              </transition>
              <transition name="content_boxFead">
                <div class="content_box" v-show="this.showMenuIndex == 1">
                  <h3 class="content_box_title">{{ this.pvpMenuTitle.agilityToScaleAndSpecialize }}</h3>
                  <p class="content_box_text">{{ this.pvpMenuText.agilityToScaleAndSpecialize }}</p>
                </div>
              </transition>
            </div>
            <div class="pvp_menu_content_box" v-show="this.showMenuIndex == 2">
              <transition name="imgBoxFead">
                <div class="imgBox" v-show="this.showMenuIndex == 2">
                  <img :src="this.pvpMenuImg.customerLoyalty" alt="Customer loyalty" />
                </div>
              </transition>
              <transition name="content_boxFead">
                <div class="content_box" v-show="this.showMenuIndex == 2">
                  <h3 class="content_box_title">{{ this.pvpMenuTitle.customerLoyalty }}</h3>
                  <p class="content_box_text">{{ this.pvpMenuText.customerLoyalty }}</p>
                </div>
              </transition>
            </div>
            <div class="pvp_menu_content_box" v-show="this.showMenuIndex == 3">
              <transition name="imgBoxFead">
                <div class="imgBox" v-show="this.showMenuIndex == 3">
                  <img :src="this.pvpMenuImg.keepingLeading" alt="Keeping leading" />
                </div>
              </transition>
              <transition name="content_boxFead">
                <div class="content_box" v-show="this.showMenuIndex == 3">
                  <h3 class="content_box_title">{{ this.pvpMenuTitle.keepingLeading }}</h3>
                  <p class="content_box_text">{{ this.pvpMenuText.keepingLeading }}</p>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="program_principles">
        <p class="pp_line"></p>
        <h3 class="pp_title">PROGRAM PRINCIPLES</h3>
        <div class="pp_card">
          <div class="pp_card_item" v-for="(item, index) in this.programPrinciplesData" :key="item.id"
            @mouseover="handlehover('over', index)" @mouseleave="handlehover('leave')" ref="pp_card_item">
            <div class="pp_card_item_img">
              <img :src="item.imgUrlOut" :alt="item.title" class="imgUrlOut" />
              <img :src="item.imgUrlEnt" :alt="item.title" class="imgUrlEnt" />
            </div>
            <div class="pp_card_item_title">{{ item.title }}</div>
            <div class="pp_card_item_text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="sangfor_Company_Profile">
        <p class="scp_line"></p>
        <h3 class="scp_title">SANGFOR COMPANY PROFILE</h3>
        <div class="scp_card">
          <div class="scp_card_item" v-for="item in this.scpCradData" :key="item.id">
            <div class="scp_card_item_color"></div>
            <div class="scp_card_title">
              <img :src="item.imgUrl" :alt="item.title" />
              <h3>{{ item.title }}</h3>
            </div>
            <div class="scp_card_text">{{ item.text }}</div>
          </div>
        </div>
        <div class="scp_introduce">
          <div class="scp_introduce_banner">
            <img :src="this.scpIntroduceImg" alt="scpIntroduceImg" />
          </div>
          <div class="scp_introduce_content">
            <div class="scp_introduce_item" v-for="item in this.scpIntroduceData" :key="item.id">
              <div class="scp_introduce_item_img">
                <img :src="item.imgUrlOut" :alt="item.title" class="imgUrlOut" />
                <img :src="item.imgUrlEnt" :alt="item.title" class="imgUrlEnt" />
              </div>
              <div class="scp_introduce_item_title">
                <h3>{{ item.title }}</h3>
                <div class="scp_introduce_item_text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="partner_Engagement_Architecture">
        <p class="pea_line"></p>
        <h3 class="pea_title">PARTNER ENGAGEMENT ARCHITECTURE</h3>
        <div class="pea_img">
          <img :src="peaImgUrl" alt="partner Engagement Architecture" />
        </div>
      </div>
      <div class="partner_Engagement_Path">
        <div class="pep_content">
          <div class="pep_content_line"></div>
          <h3 class="pep_content_title">PARTNER ENGAGEMENT PATH</h3>
          <div class="pep_content_text">
            <p>
              For partners with different business model, there are three tiers including certified, gold, and platinum,
              helping you achieve
              greater value in the greater investment.
            </p>
            <p style="margin-top: 5px">We would like to introduce the benefits and requirements for partners in
              different progresses.</p>
          </div>
        </div>
        <div class="pep_img">
          <img :src="pepImgUrl" alt="partner Engagement Path" />
        </div>
      </div>
      <div class="partner_Benefits_and_Requirements">
        <div class="pbar_line"></div>
        <h3 class="pbar_title">PARTNER BENEFITS AND REQUIREMENTS</h3>
        <div class="pbar_menu">
          <ul>
            <li @click="handlePbarmenu('0')" :class="{ PbarmenuColor: showpbarMenu == 0 }">
              PARTNER BENEFITS <span v-show="showpbarMenu == 0"></span>
            </li>
            <li @click="handlePbarmenu('1')" :class="{ PbarmenuColor: showpbarMenu == 1 }">
              PARTNER REQUIREMENTS <span v-show="showpbarMenu == 1"></span>
            </li>
          </ul>
        </div>
        <div class="pbar_content" ref="pbarContentItem">
          <transition name="pbar_content_item">
            <div class="pbar_content_item pbar_content_item_pb" v-show="showpbarMenu == 0">
              <!-- <img :src="pbarMenu1" alt="Partner Benefits"> -->
              <div class="table_view">
                <table>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Certified</th>
                      <th>Gold</th>
                      <th>Platinum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="2">Discount</td>
                      <td>Product Price Discount</td>
                      <td>Standard Discount</td>
                      <td>Better Discount</td>
                      <td rowspan="17">Referring to our local country managers</td>
                    </tr>
                    <tr>
                      <td>Service Price Discount</td>
                      <td>-</td>
                      <td>Better Discount</td>
                    </tr>
                    <tr>
                      <td rowspan="4">Co-selling</td>
                      <td>Market Insight Sharing</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Integrated Solutions</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Key Account Operation</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Leads Delivering</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="4">Enablement</td>
                      <td>Online Training</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Hands on Labs</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Boot Camping</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Enablement for C-Level</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Recruitment</td>
                      <td>Candidates Transfer to Partner</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td rowspan="7">Resources</td>
                      <td>Demo</td>
                      <td>Standard Discount</td>
                      <td>Better Discount</td>
                    </tr>
                    <tr>
                      <td>Marketing development funds</td>
                      <td>Depends on the marketing proposal,50% reimbursed by SANGFOR</td>
                      <td>Depends on the marketing proposal,60% reimbursed by SANGFOR</td>
                    </tr>
                    <tr>
                      <td>Marketing Library</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Brand Exposure in Marketing Event</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Experts Support</td>
                      <td>-</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                    <tr>
                      <td>Sales Incentives</td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                      <td>
                        <div class="triangle"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </transition>
          <transition name="pbar_content_item">
            <div class="pbar_content_item pbar_content_item_pr" v-show="showpbarMenu == 1">
              <div class="table_view">
                <table>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Item</th>
                      <th>Certified</th>
                      <th>Gold</th>
                      <th>Platinum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Sales Performance</td>
                      <td>Sales Performance</td>
                      <td>$30K</td>
                      <td>$80K</td>
                      <td rowspan="3">Referring to our local country managers</td>
                    </tr>
                    <tr>
                      <td rowspan="2">Competency</td>
                      <td>Solution Competency</td>
                      <td>-</td>
                      <td>1 junior</td>
                    </tr>
                    <tr>
                      <td>Service Competency</td>
                      <td>-</td>
                      <td>1 junior</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>For the sales performance in emerging offices, please refer to local channel sales managers.</p>
            </div>
          </transition>
        </div>
      </div>
      <div class="integrated_Solutions">
        <div class="is_line"></div>
        <h3 class="is_title">INTEGRATED SOLUTIONS</h3>
        <p class="is_text">
          Build integrated solutions base on partner's own business and characteristic that could solve pain points of
          our joint customers,
          with our market insight.
        </p>
        <div class="is_content">
          <div class="is_content_line"></div>
          <div class="is_content_item" v-for="item in this.integratedSolutionsData" :key="item.id">
            <div class="is_content_item_steps">
              <i class="el-icon-arrow-right steps_icon" v-if="item.id > 1"></i>
              <p class="steps">{{ item.id }}</p>
            </div>
            <h3 class="is_content_item_title">{{ item.title }}</h3>
            <p class="is_content_item_text">{{ item.text }}</p>
            <div class="is_content_item_img">
              <img :src="item.imgUrl" :alt="item.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="key_Account_Operation">
        <div class="kao_line"></div>
        <h3 class="kao_title">KEY ACCOUNT OPERATION</h3>
        <div class="kao_content">
          <div class="kao_content_left">
            <div class="kao_left_item" :class="'item' + item.id" v-for="item in this.kaoContentData.left"
              :key="item.id">
              <div class="kao_left_item_title">
                <h3>{{ item.title }}</h3>
                <img :src="item.imgUrl" :alt="item.title" />
              </div>
              <div class="kao_left_item_text">
                <p v-for="child in item.text" :key="child.id">{{ child.count }}<span></span></p>
              </div>
            </div>
          </div>
          <div class="kao_content_centent">
            <img :src="this.kaoContentData.centerImg" alt="key Account Operation" />
          </div>
          <div class="kao_content_right">
            <div class="kao_right_item" :class="'item' + item.id" v-for="item in this.kaoContentData.right"
              :key="item.id">
              <div class="kao_right_item_title">
                <img :src="item.imgUrl" :alt="item.title" />
                <h3>{{ item.title }}</h3>
              </div>
              <div class="kao_right_item_text">
                <p v-for="child in item.text" :key="child.id"><span></span>{{ child.count }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="explanation_for_Other_Benefits">
        <div class="efob_line"></div>
        <h3 class="efob_title">EXPLANATION FOR OTHER BENEFITS</h3>
        <div class="efob_count">
          <div class="efob_count_item" v-for="item in this.efobData" :key="item.id">
            <img :src="item.imgUrl" :alt="item.title" />
            <div class="efob_count_item_title">
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
        <p class="efob_infoText">
          Sales Incentive，made for demand generation activities and POs partner sales and pre-sales got every year.
        </p>
        <div class="download">
          <ul>
            <li v-for="item in this.downloadData" :key="item.id" @click="downFeil(item.name)">
              <p :title="item.name">{{ item.name }}</p>
              <img :src="item.imgUrl" :alt="item.name" class="donwout" />
              <img :src="item.imgUrl1" :alt="item.name" class="donwent" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footerCompontent></footerCompontent>
    <transition name="backTop"><back-to-top @click.native="handleBackTop" v-show="this.showBcakTop"></back-to-top>
    </transition>
  </div>
</template>

<script>
import navComponment from '../../components/navComponment.vue'
import footerCompontent from '../../components/footerCompontent.vue'
import backToTop from '../../components/backToTop.vue'
import { backTopMixin } from '../../mixis/backTopMixin'
import Lockr from 'lockr'
import { getUrlKey,getCurrentHost } from '@/utils/index.js'
import { Encrypts } from '@/utils/secret.js'
import { addAuth } from '@/utils/auth'
import { Message } from 'element-ui'
import { removeAuth } from '@/utils/auth'
import { getUserAndTokenByCode, pptokenJump, getPpuserInfo, removePpToken } from '@/api/login.js'
export default {
  name: 'detailsPage',
  mixins: [backTopMixin],
  components: { navComponment, footerCompontent, backToTop },
  data() {
    return {
      showMenuIndex: 0,
      showPpCardImg: true,
      showpbarMenu: 0,
      showDonw: 0,
      pbarContentItemHeight: 0,
      pvpMenuListData: [
        { id: '1', title: 'Operation Excellence' },
        { id: '2', title: 'Agility to Scale and Specialize' },
        { id: '3', title: 'Customer Loyalty' },
        { id: '4', title: 'Keeping Leading' }
      ],
      pvpMenuImg: {
        operationExcellence: require('../../assets/img/OperationExcellence.png'),
        agilityToScaleAndSpecialize: require('../../assets/img/Agilitytoscale andspecialize.png'),
        customerLoyalty: require('../../assets/img/Customerloyalty.png'),
        keepingLeading: require('../../assets/img/Keepingleading.png')
      },
      pvpMenuTitle: {
        operationExcellence: 'Operation Excellence',
        agilityToScaleAndSpecialize: 'Agility to Scale and Specialize',
        customerLoyalty: 'Customer Loyalty',
        keepingLeading: 'Keeping Leading'
      },
      pvpMenuText: {
        operationExcellence:
          'Partner could get pro-active and full sales support across the sales cycle, helping to improve efficiency in operation both internal and cooperation with vendors and customers,  including leads nutration, demand generation, project protection, technical recognition in end users, bidding, high margin support, delivery and services etc.',
        agilityToScaleAndSpecialize:
          "Since SANGFOR's business and organization structure are designed as partner oriented, partners could easily specialize in security and cloud business with our competitive products,solutions, and services to help their customers scale and succeed, with low learning cost and investment.",
        customerLoyalty:
          "With our best technical support, partners could get fastest response and handling the technical issues whether their customer big or not, and partners could provide auxiliary services to their customers with SANGFOR's help.",
        keepingLeading:
          'We are always innovative both in business models and cutting-edge solutions, and would involve partners together deeply.'
      },
      programPrinciplesData: [
        {
          id: '1',
          imgUrlEnt: require('../../assets/img/ndsEnt.png'),
          imgUrlOut: require('../../assets/img/ndsOut.png'),
          title: 'No Direct Sales',
          text: 'Work together with partners'
        },
        {
          id: '2',
          imgUrlEnt: require('../../assets/img/nplEnt.png'),
          imgUrlOut: require('../../assets/img/nplOut.png'),
          title: 'No Pre-Load',
          text: 'audit@Sangfor.com'
        },
        {
          id: '3',
          imgUrlEnt: require('../../assets/img/fsEnt.png'),
          imgUrlOut: require('../../assets/img/fsOut.png'),
          title: 'Full Support',
          text: 'provide full support across sales cycle '
        },
        {
          id: '4',
          imgUrlEnt: require('../../assets/img/hbpEnt.png'),
          imgUrlOut: require('../../assets/img/hbpOut.png'),
          title: 'High Business Profitability',
          text: 'Reserve sufficient profit for partners and nurture more business'
        }
      ],
      scpCradData: [
        {
          id: 1,
          imgUrl: require('../../assets/img/scpCardImg.png'),
          title: 'Mission',
          text: "Making each user's digital transformation easier and more secure"
        },
        { id: 2, imgUrl: require('../../assets/img/scpCardImg.png'), title: 'Vision', text: 'Carry and protect the IT of every user' },
        {
          id: 3,
          imgUrl: require('../../assets/img/scpCardImg.png'),
          title: 'Goal',
          text: 'To be a global leading enterprise-level network security and cloud computing vendor'
        }
      ],
      scpIntroduceImg: require('../../assets/img/scpIntroduceImg.png'),
      scpIntroduceData: [
        {
          id: 1,
          imgUrlEnt: require('../../assets/img/scp_1_ent.png'),
          imgUrlOut: require('../../assets/img/scp_1_out.png'),
          title: '10,000+ Employees',
          text: '40%R&D'
        },
        {
          id: 2,
          imgUrlEnt: require('../../assets/img/scp_2_ent.png'),
          imgUrlOut: require('../../assets/img/scp_2_out.png'),
          title: '3 Call Centers',
          text: 'Kuala Lumpur（MY), Shenzhen, Changsha(CN)'
        },
        {
          id: 3,
          imgUrlEnt: require('../../assets/img/scp_3_ent.png'),
          imgUrlOut: require('../../assets/img/scp_3_out.png'),
          title: '5 R&D Center',
          text: 'Silicon Valley, Beijing, Nanjing, Shenzhen, Changsha'
        },
        {
          id: 4,
          imgUrlEnt: require('../../assets/img/scp_4_ent.png'),
          imgUrlOut: require('../../assets/img/scp_4_out.png'),
          title: '60 Global Branches',
          text: 'Indonesia, Thailand, Malaysia, Singapore, Philippines, Italy, etc'
        }
      ],
      peaImgUrl: require('../../assets/img/peaImg.png'),
      pepImgUrl: require('../../assets/img/pepImg.png'),
      pbarMenu1: require('../../assets/img/pepMenu1.png'),
      integratedSolutionsData: [
        {
          id: 1,
          title: 'Market Insight',
          text: 'Know more about pain points, requirements, and key jobs for customers',
          imgUrl: require('../../assets/img/mi.png')
        },
        {
          id: 2,
          title: 'Integrated Solutions Building',
          text: "Build integrated solutions to enhance partner's competitiveness",
          imgUrl: require('../../assets/img/isb.png')
        },
        {
          id: 3,
          title: 'Demand Generation',
          text: 'Verify and optimize solutions, and generate more opportunities',
          imgUrl: require('../../assets/img/dg.png')
        }
      ],
      kaoContentData: {
        left: [
          {
            id: 1,
            title: 'Definition',
            text: [
              { id: 1, count: 'Focus on the key accounts with joint visiting and marketing activities, to contribute more value to them' }
            ],
            imgUrl: require('../../assets/img/Definition.png')
          },
          {
            id: 2,
            title: 'Partner Standard',
            text: [
              { id: 1, count: 'Good relationship with customers in C-level' },
              { id: 2, count: 'Consistent sales revenue coming from the accounts' }
            ],
            imgUrl: require('../../assets/img/PartnerStandard.png')
          }
        ],
        centerImg: require('../../assets/img/kaoIphone.png'),
        right: [
          {
            id: 1,
            title: 'Customer Standard',
            text: [{ id: 1, count: 'Larger customers with big influence in their own industry or sub-industry' }],
            imgUrl: require('../../assets/img/customerStandard.png')
          },
          {
            id: 2,
            title: 'Target',
            text: [
              { id: 1, count: 'Cross sell and up sell' },
              { id: 2, count: 'Reference sites' },
              { id: 3, count: 'Customer loyalty both to partners and Sangfor' }
            ],
            imgUrl: require('../../assets/img/Target.png')
          }
        ]
      },
      efobData: [
        {
          id: 1,
          title: 'Enablement for C-level',
          text: 'Business strategy, corporate culture, business management, coaching, etc.',
          imgUrl: require('../../assets/img/efc.png')
        },
        {
          id: 2,
          title: 'Candidates Transfer to Partners',
          text: 'Candidates which we found fit for partners in our monthly interview would be transfer to partners, as well as the coaching process and methods in the probation period.',
          imgUrl: require('../../assets/img/ctp.png')
        },
        {
          id: 3,
          title: 'Marketing library',
          text: 'Digital marketing campaigns, social media, EDM, and other materials prepared for partners to do marketing events easily.',
          imgUrl: require('../../assets/img/ml.png')
        },
        {
          id: 4,
          title: 'Experts Support',
          text: 'Experts in HQ would support our partners directly to do the internal enablement for specific topic, and help to do the technical recognition for end users.',
          imgUrl: require('../../assets/img/es.png')
        }
      ],
      downloadData: [
        // {id:1,name:'Sangfor Partner Engagement Program v2.1.pptx',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        // {id:2,name:'Share the new future with SI Partners v2.1.pptx',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        // {id:3,name:'Share the new future with DC-SI partners',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        // {id:4,name:'Engagement Program for MCP partners.pptx',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        // {id:5,name:'Engagement Program for MSP partners.pptx',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        // {id:6,name:'Engagement Program for ISV Partners v2.1.pptx',imgUrl:require('../../assets/img/download.png'),imgUrl1:require('../../assets/img/donwload1.png')},
        {
          id: 1,
          name: 'Sangfor partner engagement program.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        },
        {
          id: 2,
          name: 'Share the new future with DC-SI partners.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        },
        {
          id: 3,
          name: 'Share the new future with SI partners.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        },
        {
          id: 4,
          name: 'Engagement program for ISV partners.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        },
        {
          id: 5,
          name: 'Engagement program for MSP partners.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        },
        {
          id: 6,
          name: 'Sangfor managed cloud service to alliance partner.pdf',
          imgUrl: require('../../assets/img/download.png'),
          imgUrl1: require('../../assets/img/donwload1.png')
        }
      ]
    }
  },
  created() {
    
    console.log('%c [  ]-670', 'font-size:13px; background:pink; color:#bf2c9f;')
    let hostName = window.location.hostname;
    let {NODE_ENV,VUE_APP_ML_HOST,VUE_APP_EU_REDIRECT_URI,VUE_APP_REDIRECT_URI,VUE_APP_API_PPHOST,VUE_APP_EU_API_PPHOST} = process.env
    let code = getUrlKey('code')
    if (code) {
      const linkObj = JSON.parse(localStorage.getItem('linkObj'))
      this.showWhite = true
      getUserAndTokenByCode({
         code,
         redirectUri:getCurrentHost(VUE_APP_REDIRECT_URI,VUE_APP_EU_REDIRECT_URI),
         type:NODE_ENV === "production" && hostName != VUE_APP_ML_HOST ? "eu" : "mo",
      })
        .then(res => {
          console.log(JSON.stringify(res), 'getUserAndTokenByCode')
          if (res) {
            const { data } = res
            if (data.code == '4000302') {
              // this.$router.go(0);
              this.reFresh()
              return
            }
            if (data.token) {
              localStorage.setItem('idt_token', data.token)
            }
            if (data.toPortalsUrl) {
              localStorage.setItem('to_portals-url', data.toPortalsUrl)
              window.open(data.toPortalsUrl)
            }
            console.log('%c [  ]-738', 'font-size:13px; background:pink; color:#bf2c9f;', data.email)
            console.log('%c [  ]-734', 'font-size:13px; background:pink; color:#bf2c9f;', JSON.stringify(data))
            console.log('%c [  ]-689', 'font-size:13px; background:pink; color:#bf2c9f;', linkObj)
            if (data.email) {
              // if (linkObj && linkObj.scene && linkObj.scene === 'navJump') {
              pptokenJump({
                  email: data.email,
                  clientId: "sangfor",
                  clientSecret: "webApp",
                  type:NODE_ENV === "production" && hostName != VUE_APP_ML_HOST ? "eu" : "mo"
                })
                .then(res1 => {
                  console.log(res1, '====pptokenJump')
                  if (res1.data.code == 403) {
                    // this.$router.go(0);
                    this.reFresh()
                    return
                  }
                  localStorage.setItem('access_token_mh', res1.data.token.access_token)
                  Lockr.set('access_pp_token', res1.data.token.access_token)
                  addAuth(res1.data.token.access_token)
                  // 获取用户信息
                  getPpuserInfo()
                    .then(res2 => {
                      try {
                        console.log('%c [  ]-754', 'font-size:13px; background:pink; color:#bf2c9f;', JSON.stringify(res2))
                        if (!res2.data || !res2.data.user) {
                          Message({
                            message: this.$t('userMessage'),
                            type: 'warning',
                            duration: 5 * 1000,
                            showClose: true
                          })
                          this.$router.push({ path: '/', })
                          return
                        }
                        this.$store.commit('SET_USERINFO', res2.data.user)
                        let passParams = {
                          ...res2.data.user,
                          userType: 'Partner'
                        }
                        passParams = Encrypts(JSON.stringify(passParams))
                        localStorage.setItem('sp_info', passParams)
                        this.$store.commit('SET_SPUSERINFO', passParams)
                        localStorage.setItem('userInfo', JSON.stringify(res2.data.user))

                        console.log('%c [  ]-774', 'font-size:13px; background:pink; color:#bf2c9f;', JSON.stringify(linkObj))
                        if (data.toPortalsUrl) {
                          this.reFresh()
                          return
                        }
                        let hostData =  getCurrentHost(VUE_APP_API_PPHOST,VUE_APP_EU_API_PPHOST)
                        if (linkObj && linkObj.scene && linkObj.scene === 'navJump') {
                          if (linkObj.url2) {
                            window.open(hostData + linkObj.url)
                          } else {
                            window.open(hostData + linkObj.url)
                          }
                          localStorage.removeItem('linkObj')
                        } else {
                          window.open(hostData)
                        }
                      } catch (error) {
                        console.log('%c [  ]-733', 'font-size:13px; background:pink; color:#bf2c9f;', error)
                      }
                      this.reFresh()
                    })
                    .catch(err => {
                      console.log('%c [  ]-743', 'font-size:13px; background:pink; color:#bf2c9f;', err)
                      this.reFresh()
                      Message({
                        message: this.$t('userMessage'),
                        type: 'warning',
                        duration: 5 * 1000,
                        showClose: true
                      })
                    })
                })
                .catch(err => {
                  console.log('%c [  ]-755', 'font-size:13px; background:pink; color:#bf2c9f;', err)
                  Message({
                    message: this.$t('userMessage'),
                    type: 'warning',
                    duration: 5 * 1000,
                    showClose: true
                  })
                })
              // }
            }
          }
        })
        .catch(() => {
          // this.$router.go(0);
          this.reFresh()
        })
    }
  },
  methods: {
    removeLocalStorage() {
      localStorage.removeItem('access_token_mh')
      localStorage.removeItem('idt_token')
      Lockr.set('access_pp_token', '')
      localStorage.removeItem('sp_info')
      removeAuth()
      localStorage.removeItem('userInfo')
      // 清除store
      this.$store.commit('SET_USERINFO', {})
      this.$store.commit('SET_SPUSERINFO', {})
      // this.$router.push({ path: '/' })

      console.log('%c [  ]-793', 'font-size:13px; background:pink; color:#bf2c9f;')
      // this.$router.push({ path: '/login', query: { scene: 'login' } })
      location.replace(process.env.VUE_APP_LOGIN_D365)
    },
    // idt注销
    logOutIdt() {
      console.log('%c [  ]-797', 'font-size:13px; background:pink; color:#bf2c9f;')
      removePpToken(localStorage.getItem('idt_token'), localStorage.getItem('access_pp_token'))
        .then(res => {
          this.removeLocalStorage()
        })
        .catch(() => {
          this.$message({
            message: 'Unregistration failed.',
            type: 'warning'
          })
        })
    },
    reFresh() {
      this.showWhite = false
      if (localStorage.getItem('fromPath')) {
        this.$router.push(localStorage.getItem('fromPath'))
      } else {
        location.href = location.pathname
      }
    },
    handleMenu(index) {
      this.showMenuIndex = index
    },
    handlehover(data, index) {
      if (data == 'over') {
        // this.showPpCardImg=false;
        // this.$refs.pp_card_item[index].style.boxShadow='3px 11px 21px rgba(151, 173, 229, 0.38);'
        // console.log(this.$refs.pp_card_item[index],index);
      }
    },
    handlePbarmenu(index) {
      this.showpbarMenu = index
      console.log(this.showpbarMenu)
      if (index == 1) {
        this.$refs.pbarContentItem.style.transtion = 'height 0.3s'
        this.$refs.pbarContentItem.style.height = '210px'
      } else {
        this.$refs.pbarContentItem.style.height = '650px'
        this.$refs.pbarContentItem.style.transtion = 'height 0.3s'
      }
    },
    downFeil(item) {

      var a = document.createElement('a')
      var filename = item
      // a.href = "http://" + item.fileUrl;
      a.href = getCurrentHost() + item
      // a.href ="http://200.200.4.124/data/file/"+ item;
      a.download = filename
      a.click()
    }
  }
}
</script>

<style scoped lang="scss">
.detailsPage {
  width: 100%;
  height: 100%;

  .main {
    width: 100%;
    margin: 0 auto;

    .detailsBanner {
      width: 100%;
      height: 366px;
      background: url('../../assets/img/detailsBanner.png') no-repeat;
      background-size: cover;

      .bannerText {
        width: 100%;
        padding-left: 180px;
        padding-top: 126px;

        .text_info {
          font-size: 48px;
          font-weight: bold;
          margin-bottom: 37px;
          color: #fff;
          text-align: left;
        }

        .text_line {
          width: 279px;
          height: 4px;
          background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.45) 51%, rgba(255, 255, 255, 0.98) 100%);
        }
      }
    }

    .program_Value_Propositio {
      width: 100%;
      padding: 80px 180px 0 180px;

      .pvp_introduce {
        width: 100%;

        .pvp_introduce_line {
          width: 107px;
          height: 3px;
          background: linear-gradient(to left, #ffffff 0%, #0d39a8 43%, #0d39a8 100%);
        }

        .pvp_introduce_title {
          font-size: 32px;
          color: #2d2f36;
          text-align: left;
          padding: 20px 0;
        }

        .pvp_introduce_content {
          font-size: 22px;
          color: rgba(45, 47, 54, 1);
          text-align: left;
          line-height: 32px;
          padding: 10px 0;
        }
      }

      .pvp_menu {
        width: 100%;
        padding: 30px 0;

        .pvp_menu_list {
          width: 100%;
          display: flex;
          align-items: center;
          border: 1px solid #5580ee;

          li {
            width: 25%;
            height: 44px;
            line-height: 44px;
            font-size: 22px;
            color: rgba(81, 85, 94, 0.7);
            transition: all 0.3s;
          }

          .menuListBaColor {
            background: #0d39a8;
            color: #fff;
          }
        }

        .pvp_menu_content {
          width: 100%;
          padding: 58px 114px 58px 114px;

          .pvp_menu_content_box {
            width: 100%;
            display: flex;

            .imgBox {
              width: 420px;
              height: 316px;
              border-radius: 4px;
              box-shadow: 5px 13px 31px #d0d6e5;

              img {
                width: 100%;
                height: 100%;
                border-radius: 4px;
              }
            }

            .imgBoxFead-enter-active {
              transition: all 0.5s ease;
            }

            .imgBoxFead-leave-active {
              transition: all 0s ease;
            }

            .imgBoxFead-enter {
              transform: translateX(-100px);
            }

            .imgBoxFead-leave-to {
              opacity: 0;
            }

            .content_boxFead-enter-active {
              transition: all 0.5s ease;
            }

            .content_boxFead-leave-active {
              transition: all 0.1s ease;
            }

            .content_boxFead-enter {
              transform: translateX(100px);
            }

            .content_boxFead-leave-to {
              opacity: 0;
            }

            .content_box {
              width: 822px;
              margin-left: 58px;
              padding: 50px 0;

              .content_box_title {
                width: 100%;
                font-size: 28px;
                color: #2d2f36;
                text-align: left;
              }

              .content_box_text {
                width: 100%;
                margin-top: 32px;
                font-size: 22px;
                color: rgba(45, 47, 54, 1);
                line-height: 32px;
                text-align: left;
              }
            }
          }
        }
      }
    }

    .program_principles {
      width: 100%;
      background: #f4f6fc;
      padding: 67px 180px;

      .pp_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, #ffffff 0%, #0d39a8 43%, #0d39a8 100%);
      }

      .pp_title {
        font-size: 32px;
        color: #2d2f36;
        text-align: left;
        padding: 20px 0;
      }

      .pp_card {
        padding: 60px 0 40px 0;
        display: flex;
        justify-content: space-between;

        .pp_card_item {
          width: 360px;
          background: #fff;
          border-radius: 4px;
          padding: 27px 20px;
          cursor: pointer;

          &:hover {
            box-shadow: 3px 11px 21px rgba(151, 173, 229, 0.38);
            transform: translateY(-5px);
            transition: all 0.2s ease-out;

            .pp_card_item_img {
              .imgUrlOut {
                opacity: 0;
                transform: translateY(-64px);
                transition: all 0.3s;
              }

              .imgUrlEnt {
                opacity: 1;
                transform: translateY(-64px);
                transition: all 0.3s;
              }
            }
          }

          .pp_card_item_img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin: 0 auto;
            margin-bottom: 18px;

            //    display: flex;
            .imgUrlOut {
              width: 100%;
              height: 100%;
              transition: all 0.3s;
            }

            .imgUrlEnt {
              width: 100%;
              height: 100%;
              opacity: 0;
              transition: all 0.3s;
            }
          }

          .pp_card_item_title {
            width: 100%;
            margin-bottom: 16px;
            font-size: 26px;
            color: #2d2f36;
            font-weight: bold;
          }

          .pp_card_item_text {
            font-size: 20px;
            color: rgba(81, 85, 94, 1);
          }
        }
      }
    }

    .sangfor_Company_Profile {
      width: 100%;
      background: #fff;
      padding: 67px 180px 0px 180px;

      .scp_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, #ffffff 0%, #0d39a8 43%, #0d39a8 100%);
      }

      .scp_title {
        font-size: 32px;
        color: #2d2f36;
        text-align: left;
        padding: 20px 0;
      }

      .scp_card {
        display: flex;
        width: 100%;
        justify-content: space-between;

        .scp_card_item {
          width: 489px;
          box-shadow: 0px 7px 16px #dee6f8;
          padding: 5px 0;

          .scp_card_item_color {
            width: 100%;
            background: linear-gradient(117deg, #65bb10 0%, #0d39a8 100%);
            height: 3px;
          }

          .scp_card_title {
            width: 100%;
            display: flex;
            align-items: center;
            margin-top: 30px;

            img {
              width: 26px;
              height: 26px;
              margin-left: 24px;
            }

            h3 {
              font-size: 28px;
              color: #2d2f36;
              margin-left: 20px;
            }
          }

          .scp_card_text {
            width: 100%;
            font-size: 22px;
            line-height: 30px;
            padding: 9px 26px 20px 70px;
            color: rgba(81, 85, 94, 1);
            text-align: left;
          }
        }
      }

      .scp_introduce {
        width: 100%;
        display: flex;
        margin-top: 63px;

        .scp_introduce_banner {
          width: 564px;
          height: 432px;
          box-shadow: 5px 13px 31px #d0d6e5;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .scp_introduce_content {
          margin-left: 55px;
          padding: 19px 0;
          flex-direction: column;
          display: flex;
          justify-content: space-between;

          .scp_introduce_item {
            display: flex;
            align-items: center;
            cursor: pointer;

            &:hover {
              .scp_introduce_item_img {
                background: #0d39a8;

                .imgUrlOut {
                  // display: none;
                  // transition: opacity 0.3s;
                  transform: translateY(-64px);
                  transition: all 0.3s;
                }

                .imgUrlEnt {
                  // display: block;
                  transform: translateY(-64px);
                  transition: all 0.3s;
                }
              }
            }

            .scp_introduce_item_img {
              width: 60px;
              height: 60px;
              background: #a8b5d6;
              box-shadow: 2px 4px 17px rgba(168, 181, 214, 0.32);
              border-radius: 50%;
              overflow: hidden;

              .imgUrlOut {
                width: 100%;
                height: 100%;
                transition: all 0.3s;
              }

              .imgUrlEnt {
                width: 100%;
                height: 100%;
                transition: all 0.3s;
              }
            }

            .scp_introduce_item_title {
              margin-left: 30px;

              h3 {
                font-size: 28px;
                color: #2d2f36;
                text-align: left;
                //   line-height: 24px;
              }

              .scp_introduce_item_text {
                font-size: 20px;
                color: rgba(81, 85, 94, 1);
                margin-top: 12px;
                // line-height: 16px;
                text-align: left;
              }
            }
          }
        }
      }
    }

    .partner_Engagement_Architecture {
      width: 100%;
      padding: 118px 180px 36px 180px;
      //    height: 532px;
      background: url('../../assets/img/peaIntroduceBackground.png') no-repeat;
      background-size: cover;

      .pea_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, #ffffff 0%, #0d39a8 43%, #0d39a8 100%);
      }

      .pea_title {
        font-size: 32px;
        color: #2d2f36;
        text-align: left;
        padding: 20px 0;
      }

      .pea_img {
        width: 1597px;
        height: 332px;
        margin: 79px auto 0;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .partner_Engagement_Path {
      width: 100%;
      background: url('../../assets/img/pepBackground.png') no-repeat;
      background-size: cover;
      padding: 84px 180px 58px 180px;
      display: flex;

      .pep_content {
        width: 908px;

        .pep_content_line {
          width: 107px;
          height: 3px;
          background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.45) 51%, #ffffff 100%);
          margin-top: 51px;
        }

        .pep_content_title {
          width: 100%;
          font-size: 32px;
          padding: 20px 0 0 0;
          color: #fff;
          text-align: left;
        }

        .pep_content_text {
          width: 100%;
          padding: 36px 0;
          color: #fff;
          font-size: 22px;
          text-align: left;
          opacity: 0.8;

          p {
            color: #fff;
            font-size: 22px;
            text-align: left;
            opacity: 0.8;
            line-height: 32px;
          }
        }
      }

      .pep_img {
        width: 614px;
        height: 312px;
        margin-left: 172px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .partner_Benefits_and_Requirements {
      width: 100%;
      height: 100%;
      padding: 90px 180px 50px 180px;

      .pbar_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(20, 70, 196, 0.45) 51%, #1446c4 100%);
      }

      .pbar_title {
        width: 100%;
        font-size: 32px;
        color: #2d2f36;
        margin-top: 20px;
        text-align: left;
      }

      .pbar_menu {
        width: 100%;
        padding: 80px 400px 50px 400px;

        ul {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .PbarmenuColor {
            color: #2d2f36;
          }

          li {
            height: 35px;
            font-size: 28px;
            color: #7a7b80;
            margin-right: 20px;

            //font-family: Source Han Sans CN;
            span {
              width: 100%;
              height: 2px;
              background: #0d39a8;
              margin-top: 15px;
              display: block;
            }
          }
        }
      }

      .pbar_content {
        width: 100%;
        overflow: hidden;
        height: 650px;
        transition: all 0.3s;

        .pbar_content_item-enter-active {
          transition: all 1.5s;
        }

        .pbar_content_item-leave-active {
          transition: all 0s;
        }

        .pbar_content_item-enter,
        .pbar_content_item-leave-to {
          opacity: 0;
        }

        .pbar_content_item_pb {
          height: 650px;
        }

        .pbar_content_item_pr {
          height: 240px;
        }

        .pbar_content_item {
          width: 100%;

          img {
            width: 100%;
            height: 100%;
          }

          .table_view {
            width: 100%;
            padding: 20px 30px;

            .triangle {
              width: 0;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
              border-bottom: 10px solid green;
              margin: 0 auto;
            }

            table {
              width: 100%;

              thead {
                background: #0d39a8;
                color: #fff;
                border: 1px solid #0d39a8;

                tr {
                  height: 40px;
                  font-size: 18px;
                }
              }

              tbody {
                tr {
                  height: 30px;
                  font-size: 16px;

                  td {
                    width: 220px;
                    font-size: 16px;
                    border: 1px solid #dedede;
                  }
                }
              }
            }
          }

          p {
            text-align: left;
            color: #7a7b80;
            padding: 0 40px;
            font-size: 20px;
          }
        }
      }
    }

    .integrated_Solutions {
      width: 100%;
      padding: 105px 0;
      background: rgba($color: #010b24, $alpha: 0.9);

      .is_line {
        width: 107px;
        height: 3px;
        margin-left: 180px;
        text-align: left;
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.45) 51%, #ffffff 100%);
      }

      .is_title {
        font-size: 32px;
        color: #fff;
        padding: 20px 0 12px 0;
        margin-left: 180px;
        text-align: left;
      }

      .is_text {
        width: 1069px;
        height: 73px;
        color: #fff;
        margin-left: 180px;
        text-align: left;
        font-size: 22px;
        line-height: 30px;
      }

      .is_content {
        width: 100%;
        margin-top: 17px;
        display: flex;
        position: relative;
        padding: 0 180px;
        justify-content: space-between;

        .is_content_line {
          width: 100%;
          height: 1px;
          background: #e5ecff;
          position: absolute;
          top: 19px;
          left: 0;
          opacity: 0.9;
        }

        .is_content_item {
          width: 360px;
          z-index: 9;

          .is_content_item_steps {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(239, 244, 255, 0.2);
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            .steps_icon {
              position: absolute;
              left: -10px;
              top: 14px;
              opacity: 0.7;
              color: #fff;
            }

            .steps {
              width: 32px;
              height: 32px;
              text-align: center;
              line-height: 32px;
              border-radius: 50%;
              color: #fff;
              background: #0d39a8;
              font-size: 14px;
              cursor: default;
            }
          }

          .is_content_item_title {
            font-size: 28px;
            color: #fff;
            margin: 30px 0 15px;
            width: 400px;
            height: 80px;
            text-align: left;
          }

          .is_content_item_text {
            font-size: 22px;
            color: #fff;
            opacity: 0.7;
            text-align: left;
            margin: 15px 0 20px;
            height: 65px;
            width: 450px;
            line-height: 32px;
          }

          .is_content_item_img {
            width: 100%;
            height: 211px;
            margin-top: 15px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .key_Account_Operation {
      width: 100%;
      background: #f4f6fc;
      padding: 56px 180px 60px 180px;

      .kao_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(20, 70, 196, 0.45) 51%, #1446c4 100%);
      }

      .kao_title {
        width: 100%;
        color: #2d2f36;
        font-size: 32px;
        margin-top: 20px;
        text-align: left;
      }

      .kao_content {
        width: 100%;
        margin-top: 23px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .kao_content_left {
          height: fit-content;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-top: 62px;
          margin-right: 24px;

          .item1 {
            margin-bottom: 40px;
          }

          .kao_left_item {
            width: 520px;
            background: #fff;
            border-radius: 4px;
            padding: 20px 0;
            cursor: pointer;

            &:hover {
              transform: translateY(-3px);
              box-shadow: 3px 11px 21px rgba(151, 173, 229, 0.38);
              transition: all 0.2s;
            }

            .kao_left_item_title {
              display: flex;
              align-items: center;
              justify-content: flex-end;

              h3 {
                font-size: 28px;
                color: #2d2f36;
                margin-right: 12px;
              }

              img {
                width: 33px;
                height: 33px;
                margin-right: 25px;
              }
            }

            .kao_left_item_text {
              text-align: right;
              margin-right: 43px;
              margin-top: 19px;
              font-size: 20px;

              p {
                position: relative;
                line-height: 30px;
                margin-bottom: 5px;
                color: rgba(81, 85, 94, 1);
              }

              span {
                width: 6px;
                height: 6px;
                border: 1px solid #65bb10;
                border-radius: 50%;
                display: inline-block;
                position: absolute;
                top: 12px;
                right: -20px;
              }
            }
          }
        }

        .kao_content_centent {
          width: 306px;
          height: 570px;
          box-shadow: 0px 11px 26px rgba(194, 204, 229, 0.85);
          border-radius: 34px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .kao_content_right {
          height: fit-content;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-top: 174px;
          margin-left: 24px;

          .item1 {
            margin-bottom: 40px;
          }

          .kao_right_item {
            width: 520px;
            background: #fff;
            border-radius: 4px;
            padding: 20px 0;
            cursor: pointer;

            &:hover {
              transform: translateY(-3px);
              box-shadow: 3px 11px 21px rgba(151, 173, 229, 0.38);
              transition: all 0.2s;
            }

            .kao_right_item_title {
              display: flex;
              align-items: center;
              justify-content: flex-start;

              h3 {
                font-size: 28px;
                color: #2d2f36;
                margin-left: 12px;
              }

              img {
                width: 33px;
                height: 33px;
                margin-left: 25px;
              }
            }

            .kao_right_item_text {
              text-align: left;
              margin-left: 43px;
              margin-top: 19px;
              font-size: 20px;

              p {
                position: relative;
                line-height: 30px;
                margin-bottom: 5px;
                color: rgba(81, 85, 94, 1);
              }

              span {
                width: 6px;
                height: 6px;
                border: 1px solid #65bb10;
                border-radius: 50%;
                display: block;
                position: absolute;
                top: 12px;
                left: -20px;
              }
            }
          }
        }
      }
    }

    .explanation_for_Other_Benefits {
      width: 100%;
      padding: 70px 180px 170px 180px;
      position: relative;

      .efob_line {
        width: 107px;
        height: 3px;
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(20, 70, 196, 0.45) 51%, #1446c4 100%);
      }

      .efob_title {
        width: 100%;
        text-align: left;
        font-size: 32px;
        color: #2d2f36;
        margin-top: 20px;
      }

      .efob_count {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        padding: 35px 0;

        .efob_count_item {
          display: flex;
          margin-top: 40px;

          &:hover {
            img {
              transform: translateY(-3px);
              transition: all 0.3s;
            }
          }

          img {
            width: 252px;
            height: 191px;
            box-shadow: 2px 6px 31px rgba(127, 140, 175, 0.6);
          }

          .efob_count_item_title {
            width: 460px;
            margin-left: 30px;

            h3 {
              font-size: 28px;
              color: #2d2f36;
              text-align: left;
              //    margin-top: 25px;
            }

            p {
              font-size: 20px;
              color: rgba(81, 85, 94, 1);
              line-height: 30px;
              text-align: left;
              margin-top: 16px;
            }
          }
        }
      }

      .efob_infoText {
        font-size: 20px;
        color: #51555e;
        width: 100%;
        text-align: left;
      }

      .download {
        width: 100%;
        padding: 13px 46px;
        position: absolute;
        box-shadow: 0px 3px 12px #c4cee8;
        bottom: 50px;
        left: 0;

        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;

          li {
            width: 16%;
            height: 40px;
            padding: 0 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 1px solid #b7cbff;
            border-radius: 4px;
            transition: all 0.5s;

            p {
              font-size: 14px;
              color: #0d39a8;
              overflow: hidden;
              width: 90%;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            &:hover {
              background: #0d39a8;

              p {
                color: #fff;
              }

              .donwout {
                display: none;
              }

              .donwent {
                display: block;
              }
            }

            .donwout {
              width: 5.5%;
              height: 14px;
            }

            .donwent {
              display: none;
              width: 5.5%;
              height: 14px;
            }
          }
        }
      }
    }
  }
}
</style>